import classNames from 'classnames';
import { FunctionComponent } from 'react';
import Stars from './Stars';
import styles from './styles.module.scss';

export type StarRatingProps = {
    rating: number;
    maxRating?: number;
    onChange?: (rating: number) => void;
    className?: string;
};

const StarRating: FunctionComponent<StarRatingProps> = ({
    rating,
    onChange,
    maxRating = 5,
    className,
}) => {
    return (
        <div className={classNames(styles.rating, className)}>
            <Stars rating={rating} maxRating={maxRating} onClick={onChange} />
        </div>
    );
};

export default StarRating;
